import { servicePost } from "./client.ts";

/** A licensing plan row (mirrors IDS.License). */
export interface License {
    LicenseType: string;
    LicenseAgreement: string;
    LicenseCount: number;
    /** Pending removal amount (shown to the user as a negative). */
    CurrentDecreased: number;
    /** Largest allowed decrease for this type (counter min = -MinimumCount). */
    MinimumCount: number;
}

export function getLicenses() {
    return servicePost<License[]>("WebGetLicenses", {});
}

/** Paid licences vs. what the endpoint's kiosks consume, one row per licence type. */
export interface LicenseUsage {
    /** Kiosk model the licences apply to; "" is the catch-all/generic bucket. */
    LicenseType: string;
    /** Paid licences for this type. `null` = unlimited. */
    LicensedCount: number | null;
    /** Licences consumed: 1 per kiosk, plus one per IQBox in a store kiosk. Not capped
     *  by `LicensedCount` — over-deployment is meant to be visible. */
    UsedWeight: number;
    /** Kiosks counted in `UsedWeight` (excludes non-LIVE kiosks that stopped reporting). */
    KioskCount: number;
}

/**
 * Licence usage for the active endpoint, for the header counter. Returns an empty array
 * when the partner has no licence rows at all — the counter hides itself on that.
 * Server-side cached 10 minutes per endpoint.
 */
export function getLicenseUsage() {
    return servicePost<LicenseUsage[]>("WebGetLicenseUsage", {});
}

/** Increase a license type's count by `addCount` (charged next invoice). */
export function addLicenses(licenseType: string, addCount: number) {
    return servicePost<boolean>("WebAddLicenses", { licenseType, addCount });
}

/** Request a decrease of `amount` licenses for the given plan. */
export function removeLicenses(amount: number, license: License) {
    return servicePost<boolean>("WebRemoveLicenses", { amount, license });
}
